module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/view/management-details/management/management.component.css
// module id = ./src/app/pages/view/management-details/management/management.component.css
// module chunks = main